const dataLabelFormat = (name) => {
    if (!name) {
        return '';
    }
    return name.toLowerCase().replaceAll(' ', '-').replace('™', '');
};

export { dataLabelFormat };
//# sourceMappingURL=userClickHandler.js.map
